// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__RCHjb","header":"App_header__2L3DO","title":"App_title__2oBiX","description":"App_description__A-JFl"};